import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import React, {useEffect, useState} from "react";
import QRCode from "react-qr-code";
import {NavMenu} from "../../components/GetNavMenu";
import {Footer} from "../../components/GetFooter";
import {HTTPError} from "../../models/errors/HTTPError";
import {ApiDataHelper} from "../../data/ApiDataHelper";
import {TwoFAEnableModel} from "../../models/authentication/TwoFAEnableModel";
import {Alert, Container, Grid, Space, Table, Text, Title} from "@mantine/core";
import {IconAlertCircle, IconCheckbox, IconKey} from "@tabler/icons";
import {ContainerLoader} from "../../components/loader/ContainerLoader";

export function Enable2FA({memory}: SystemMemoryProps) {
    // Create navigation states
    const [Content, setContent] = useState(<ContainerLoader />);

    // Get the 2FA secret from the server
    async function Get2FASecret() {
        // Load the user's account dashboard
        const Api = new ApiDataHelper({memory: memory});

        let data = undefined;
        try {
            data = await Api.Execute<TwoFAEnableModel>('/auth/2fa/enable', {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }, false);
        } catch (e) {
            // Check for HttpError
            if (e instanceof HTTPError) {
                if (e.code === 406) {
                    // If the user has already enabled 2FA, display a message to say so
                    data = undefined;
                    setContent(
                        <Container>
                            <Space h="lg"/>
                            <Alert icon={<IconCheckbox size="1rem"/>} title="2FA Enabled!" color="green" variant="light">
                                You have already enabled 2FA on your account. If you have lost access to your authenticator app, please contact an administrator.
                            </Alert>
                        </Container>
                    );
                } else {
                    // If the error has no method to handle it then throw it
                    throw e;
                }
            } else {
                // If the error is not an HTTPError then throw it
                throw e;
            }
        }

        // Set the QR code
        if (data !== undefined) {
            // Purge any instance of 'account' from local cache
            await Api.PurgeCache('/v1/account', JSON.stringify({
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }));

            // Get the token
            setContent(
                <Container>
                    <Space h="lg"/>
                    <Alert icon={<IconAlertCircle size="1rem"/>} title="Warning!" color="orange" variant="light">
                        Do not leave this page until you have saved the 2FA secret in your authenticator app, you will not be able to view it again.
                    </Alert>
                    <Space h="lg"/>
                    <Grid>
                        <Grid.Col md={12} lg={6}><center><QRCode
                            value={`otpauth://totp/${data.name}:${data.email}?secret=${data.token}&issuer=TOMSW.UK`}>
                            height={'auto'}
                            width={'75%'}
                        </QRCode></center></Grid.Col>
                        <Grid.Col md={12} lg={6}>
                            <center>
                                <Title align="center">Instructions</Title>
                                <Text size={'h2'} align="center">Scan the QR code with your authenticator app to setup
                                    2FA. If the QR code does not work, you can manually enter the secret using the
                                    information below.</Text>
                                <Space h="lg"/>
                                <Table highlightOnHover>
                                    <thead>
                                    <tr>
                                        <td align={'center'}><Title size={18}><IconKey size={18}/> 2FA Secret:</Title>
                                        </td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td align={'center'}><Text size={18}>{data.token}</Text></td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </center>
                        </Grid.Col>
                    </Grid>
                </Container>
            );
        }
    }

    // Load the QR code
    useEffect(() => { Get2FASecret() }, []);

    return (
        <><NavMenu memory={memory}></NavMenu>
            {Content}
        <Footer data={[]}></Footer></>
    );
}